/** Formate les montants Stripe Balance (centimes) pour l’affichage. */
export function formatConnectBalanceLines(balance) {
  if (!balance || typeof balance !== "object") return { available: "—", pending: "—" };
  const fmt = (parts, code) => {
    const list = Array.isArray(parts) ? parts : [];
    const entry = list.find((p) => String(p?.currency || "").toLowerCase() === code);
    if (!entry || typeof entry.amount !== "number") return "—";
    const major = entry.amount / 100;
    return major.toLocaleString("fr-FR", { style: "currency", currency: code.toUpperCase() });
  };
  return {
    available: fmt(balance.available, "eur"),
    pending: fmt(balance.pending, "eur"),
  };
}
